import { get } from 'svelte/store';
import { user_settings } from 'src/stores/account/user';
import type { ChartControlsDataInterface } from 'src/helpers/statistics/ui/chart_control_helpers';
import type { Device } from 'src/types/Device';
import type { EnergyStatisticsResult, FetchEnergyStatisticsOptions } from './fetch_energy_statistics';
import { getEnergyStatistics } from './energy_statistics_repository';
import type { EnergyMonitoringPeriodId } from './period_helpers';

export const fetchDeviceEnergyStatistics = (
	device: Device,
	controls: ChartControlsDataInterface,
	periodId: EnergyMonitoringPeriodId,
	options: FetchEnergyStatisticsOptions = {},
): Promise<EnergyStatisticsResult | null> =>
	getEnergyStatistics({
		scope: { kind: 'device', device },
		controls,
		periodId,
		currency: get(user_settings)?.currency ?? '',
		options,
	});
